<div [class.dark-theme]="true" class="fix-action-dialog" style="background-color: #24242480;">

	<!-- <div class="card-title" style="color:#ffffff;font-weight: 600;">退会手続き</div> -->
	<h2 class="mat-dialog-title dialog_title" id="mat-dialog-title-0" mat-dialog-title="" style="color: #ffffff;"><span data-idtest="payment-withdrawal-dialog-t-7Oe" translate>退会手続き</span></h2>
	<!-- <h2 mat-dialog-title style="font-size: 1.4rem;color:#ffffff;font-weight: 600;">退会手続き</h2> -->
	<mat-dialog-content>
		<mat-card class="payment-card-dialog" style="background-color: #24242480;padding:0">
			<mat-card-content class="payment-card-dialog-content">

					<div style="line-height: 2;overflow:hidden;">
						<div data-idtest="payment-withdrawal-dialog-t-7Ml" style="font-weight: 600;" translate>
							退会の申請について
						</div>
						<div data-idtest="payment-withdrawal-dialog-t-7Bg" translate>
							退会をご希望の方は以下の内容をご確認いただき、各項目へ同意のチェックをお願い致します。
						</div>
						<form #form="ngForm" fxLayout="column wrap" novalidate style="padding: 12px;background: #4F4F4F;border-radius: 1em;margin-top:12px;">
							<mat-checkbox (change)="onChecked($event)" [(ngModel)]="checked" fxFlex.lt-sm="100" fxLayout="row wrap" required><span data-idtest="payment-withdrawal-dialog-t-9Dy" translate>本日退会頂く場合、翌月のご請求は発生致しません。ご返金等の対応は一切致しかねます事をご了承ください。</span></mat-checkbox>
							<mat-checkbox (change)="onChecked1($event)" [(ngModel)]="checked1" fxFlex.lt-sm="100" fxLayout="row wrap" required><span data-idtest="payment-withdrawal-dialog-t-9Sa" translate>退会後のアカウント復旧・データの復旧対応は致しかねます。今までのスイングデータは全て削除される事をご了承下さい。</span></mat-checkbox>
							<mat-checkbox (change)="onChecked2($event)" [(ngModel)]="checked2" fxFlex.lt-sm="100" fxLayout="row wrap" required><span data-idtest="payment-withdrawal-dialog-t-4Ri" translate>再度ご入会頂いても、如何なる場合においても過去のデータは復旧不可能となります。</span></mat-checkbox>
						<!--	<mat-form-field appearance="outline" class="input-text" fxFlex="100%" style="margin:0">
								<mat-label>退会理由</mat-label>
								<textarea #description="ngModel" [(ngModel)]="content.description" matInput maxlength="500" minlength="30" name="description" placeholder="" required type="text"></textarea>
								<mat-hint>30文字以上500文字まで</mat-hint>
								<mat-error *ngIf="description.errors?.['maxlength']">長すぎます</mat-error>
							</mat-form-field> -->
						</form>
					</div>

			</mat-card-content>
		</mat-card>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.lt-sm="space-between center" style="padding: 12px 0;color:#ffffff;font-size:12px;">
		<div fxFlex="40" fxLayoutAlign="center center" style="padding-top:12px;">
			<button (click)="cancel()" color="warn" mat-dialog-close="" mat-raised-button id="mat-cancel-button"><span data-idtest="payment-withdrawal-dialog-t-4Gl" translate>キャンセル</span></button>
		</div>
		<div fxFlex="40" fxLayoutAlign="center center" style="padding-top:12px;">
			<button (click)="onAccept()" *ngIf="!(!checked || !checked1 || !checked2 || form.invalid)" [disabled]="!checked || !checked1 || !checked2 || form.invalid" color="primary" mat-raised-button id="mat-raised-button"><span data-idtest="payment-withdrawal-dialog-t-4Ov" translate>退会申請する</span></button>
			<button *ngIf="!checked || !checked1 || !checked2 || form.invalid"  [disabled]="!checked || !checked1 || !checked2 || form.invalid" mat-raised-button color="primary" ><span data-idtest="payment-withdrawal-dialog-t-1Jq" translate>退会申請する</span></button>
		</div>
	</mat-dialog-actions>
</div>
